var checkedControlStyles = {
  borderColor: 'blue.600',
  _disabled: {
    bg: 'grey.500',
    color: 'white'
  },
  _invalid: {
    bg: 'white'
  },
  _focus: {
    backgroundColor: 'blue.900'
  }
};
export var Checkbox = {
  baseStyle: {
    control: {
      border: '1px solid',
      borderRadius: '2px',
      borderColor: 'blue.600',
      _checked: checkedControlStyles,
      _indeterminate: checkedControlStyles,
      _focus: {
        border: '1px solid #00CAFF',
        boxShadow: "0 0 3px 2px #2182EB"
      },
      _invalid: {
        borderColor: 'red.700',
        borderWidth: '1.5px',
        boxShadow: 'none',
        _focus: {
          borderColor: 'red.700',
          boxShadow: "0 0 4px 1px #D0011C"
        }
      }
    }
  }
};